import type { IntlShape } from 'react-intl';

import { showErrorToast } from '@vs-shop/ui/toast';
import type { OrderViolationError } from '@vs-shop/engine/data/error/orderViolation';
import { getViolationErrorMessage } from '../../effect/utils/error/violationErrorMessage';

export const showViolationToast = (violation: OrderViolationError, intl: IntlShape): void => {
  const message = getViolationErrorMessage(violation, intl);
  showErrorToast(message);
};
